module.exports = __webpack_public_path__ + "media/back-to-school/icon-471fb63f.svg";